import React, { useState } from 'react';
import { Form, Col, Card, Row, Image, InputGroup } from 'react-bootstrap';
import md5 from 'md5';
import styles from '../../../styles.module.css';
import estenose from '../../../assets/estenose-carotida.png';
import imgcarotida from '../../../assets/carotidas.jpg';
import { getPrefix } from '../../../util/utils';
import IcmHeaderImage from '../../../components/IcmHeaderImage';
import {
  INITIAL_ARTERIA,
  parseImagem,
  razaoCiCc,
  formatRazao,
} from './arteriaImagem';

export default function ReportImagem({ carotida, printing = false }) {
  const [arteriaData, setArteriaData] = useState(() =>
    structuredClone(
      parseImagem(carotida?.carotida?.[0]?.IMAGEM) || INITIAL_ARTERIA
    )
  );

  const razaoDireita = razaoCiCc(
    arteriaData.direita?.arteriaCarotidaInterna?.velSistolica,
    arteriaData.direita?.arteriaCarotidaComum?.velSistolica
  );
  const razaoEsquerda = razaoCiCc(
    arteriaData.esquerda?.arteriaCarotidaInterna?.velSistolica,
    arteriaData.esquerda?.arteriaCarotidaComum?.velSistolica
  );

  const handleInputChange = (e, lado, artName, fieldName) => {
    const { value } = e.target;
    setArteriaData(prevData => ({
      ...prevData,
      [lado]: {
        ...prevData[lado],
        [artName]: { ...prevData[lado][artName], [fieldName]: value },
      },
    }));
  };

  const renderCards = lado => (
    <Col sm={3} className="m-0 p-0">
      <Card style={{ marginBottom: 2, textAlign: 'center' }} bg="danger">
        <h3 style={{ color: 'white' }}>{lado.toUpperCase()}</h3>
      </Card>
      {Object.keys(arteriaData[lado]).map((arteria, index) => (
        <Card
          key={index}
          style={{ marginBottom: 2, textAlign: 'center' }}
          bg="light"
        >
          <Card.Body>
            <Card.Title style={{ color: 'green' }}>
              {arteria
                .replace(/([A-Z])/g, ' $1')
                .trim()
                .toUpperCase()}
            </Card.Title>
            <div>
              <Form.Group>
                <Form.Label>Vel Sistólica:</Form.Label>
                <InputGroup>
                  <Form.Control
                    readOnly
                    type="text"
                    placeholder="Vel sistólica"
                    value={arteriaData[lado][arteria].velSistolica}
                    onChange={e =>
                      handleInputChange(e, lado, arteria, 'velSistolica')
                    }
                  />
                  <InputGroup.Text>cm/seg</InputGroup.Text>
                </InputGroup>
              </Form.Group>
              <Form.Group>
                <Form.Label>Vel Diastólica:</Form.Label>
                <InputGroup>
                  <Form.Control
                    readOnly
                    type="text"
                    placeholder="Vel diastólica"
                    value={arteriaData[lado][arteria].velDiastolica}
                    onChange={e =>
                      handleInputChange(e, lado, arteria, 'velDiastolica')
                    }
                  />
                  <InputGroup.Text>cm/seg</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </div>
            <Card.Text style={{ color: 'red' }}>Fluxo laminar</Card.Text>
          </Card.Body>
        </Card>
      ))}
    </Col>
  );

  return (
    <div>
      <style>
        {`
          @media print {
            #removeMe {
              display: none;
            }

            .page-break {
              page-break-before: always;
              break-before: always;
            }
          }
        `}
      </style>

      <div className={styles.imageReport}>
        <IcmHeaderImage showBlank={!printing} />
      </div>

      <Card.Header className="mt-3 mb-3 p-2 d-flex justify-content-center text-center align-items-center">
        <Card.Title>
          PACIENTE: {carotida?.carotida[0]?.NOMEPAC} - IDADE:{' '}
          {carotida?.carotida[0]?.idadePAC} anos <br />
          DATA LAUDO: {carotida?.carotida[0]?.dataScanFmt} - LAUDO:{' '}
          {carotida?.carotida[0]?.CODSCAN}
          <br />
        </Card.Title>
      </Card.Header>
      <Row className="m-0 p-0">
        {renderCards('direita')}

        <Col
          sm={6}
          className="mt-5 p-0 justify-content-center align-items-center"
        >
          <Image className="m-0 p-0" fluid rounded src={imgcarotida} />
          <Row>
            <Col
              sm={12}
              className="m-0 p-3 justify-content-center align-items-center text-center"
            >
              <Image className="m-0 p-0" fluid rounded src={estenose} />
            </Col>
          </Row>
          <Row>
            <Col
              sm={12}
              className="font-weight-bold mb-5 p-3 justify-content-center align-items-center text-center"
            >
              <Form.Label>Razão VPS CI/VPS CC</Form.Label>
              <Form.Group>
                <Form.Label>{`Direita <---------------> Esquerda`}</Form.Label>
                <InputGroup className="mb-5 p-3 justify-content-center align-items-center text-center">
                  <Form.Control
                    className="text-center font-weight-bold"
                    readOnly
                    type="text"
                    value={formatRazao(razaoDireita)}
                    placeholder="Direita"
                  />
                  <Form.Control
                    className="text-center font-weight-bold"
                    readOnly
                    type="text"
                    value={formatRazao(razaoEsquerda)}
                    placeholder="Esquerda"
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <div
            className="mt-5 p-2 text-center"
            style={{ fontSize: 15, color: '#449' }}
          >
            <i>Conferido e assinado eletronicamente por: </i>

            <strong>
              {getPrefix(carotida?.carotida[0]?.CODREALIZOU) || ''}{' '}
              {carotida?.carotida[0]?.Realizou}
            </strong>
            <br></br>
            <i>
              Assinatura Digital:{' '}
              {md5(JSON.stringify(carotida?.carotida[0]?.IMAGEM || ''))}
            </i>
          </div>
        </Col>

        {renderCards('esquerda')}
      </Row>
    </div>
  );
}
